import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

// Supprimer les logs i18next de la console
if (typeof console !== 'undefined') {
  const originalLog = console.log;
  console.log = function(...args) {
    // Filtrer les logs i18next
    if (args.length > 0 && typeof args[0] === 'string' && 
        (args[0].includes('i18next') || args[0].includes('translator'))) {
      return;
    }
    originalLog.apply(console, args);
  };
}

// Importation directe des traductions pour le démarrage
//import translationFR from '../public/locales/fr/translation.json';
//import translationEN from '../public/locales/en/translation.json';

// Les ressources contiennent les traductions par langue
/*const resources = {
  fr: {
    translation: translationFR
  },
  en: {
    translation: translationEN
  }
};*/

i18n
  // Chargement des traductions depuis /public/locales
  .use(Backend)
  // Détection automatique de la langue du navigateur
  .use(LanguageDetector)
  // Intégration avec React
  .use(initReactI18next)
  // Initialisation
  .init({
    fallbackLng: 'fr', // Langue par défaut si la traduction n'existe pas
    debug: false, // Désactivé pour éviter les logs perturbants

    // Important: nos fichiers de traductions sont organisés par langue (fr/en/ar)
    // et non par locale régionale (fr-FR). Sans cela, i18next tente de charger
    // /locales/fr-FR/*.json, ce qui provoque des 404 et donne l'impression que
    // la régénération ne fonctionne pas.
    supportedLngs: ['fr', 'en', 'ar'],
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    
    // Supprimer complètement les logs i18next
    missingKeyHandler: false,
    saveMissing: false,
    
    interpolation: {
      escapeValue: false, // React échappe déjà les valeurs
    },
    backend: {
      // Pour le namespace "categories", on charge depuis l'API dynamique (DB)
      // plutôt que depuis un fichier statique categories.json.
      // Pour tous les autres namespaces, le chemin statique habituel est conservé.
      loadPath: (lngs, namespaces) => {
        if (namespaces[0] === 'categories') {
          return `/api/v1/i18n/categories?lng=${lngs[0]}`;
        }
        if (namespaces[0] === 'listingFields') {
          return `/api/v1/i18n/listing-fields?lng=${lngs[0]}`;
        }
        return `/locales/${lngs[0]}/${namespaces[0]}.json`;
      },
    },
    // Namespaces par défaut
    ns: ['common', 'notifications','validation', 'categories', 'booking','dashboard',
      'messaging','conditionReport','photoCapture','photoUpload','qrConditionReport',
      'qrActionButton','qrConfirmationModal','refusalSection','cancellationReasons',
      'paymentErrors','qrCodes','financial','reviews', 'disputes', 'myReservations', 'products', 'pricing',
      'availabilityManager', 'periodFormModal','listing','reports','support','listingFields','legal','delivery'],
    defaultNS: 'common',
    // Options pour react-i18next
    react: {
      useSuspense: false,
    },
    
    // Détection de la langue
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;